export const WixCodeAppDefId = '675bbcef-18d8-41f5-800e-131ec9e08762'
export const MasterPageId = 'masterPage'
